import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/account-pending/")({
  head: () => ({
    meta: [{ title: "账号待审核 · imiker CRM" }],
  }),
  beforeLoad: ({ context }) => {
    if (typeof window === "undefined" && context.auth.status === "anonymous") {
      throw redirect({ to: "/login" });
    }
  },
});
